import { render } from "./ModalUploadBurofaxCSV.vue?vue&type=template&id=6bda7b82&scoped=true"
import script from "./ModalUploadBurofaxCSV.vue?vue&type=script&lang=js"
export * from "./ModalUploadBurofaxCSV.vue?vue&type=script&lang=js"

import "./ModalUploadBurofaxCSV.vue?vue&type=style&index=0&id=6bda7b82&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bda7b82"]])

export default __exports__